import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { createV2Transaction,updateRealizedGainV1 } from '../../composables/fetchAPI';
import { usePortfolio } from '../../context/PortfolioContext';
interface EditRealizeGainModalProps {
  isOpen: boolean;
  onClose: () => void;
  portfolioId: string;
  stock: any;
  onSave: () => void;
  subPortfolioId?: string; // เพิ่ม prop สำหรับ subPortId
}

const EditRealizeGainModal: React.FC<EditRealizeGainModalProps> = ({ isOpen, onClose, portfolioId, stock, onSave, subPortfolioId }) => {
  const [newGain, setNewGain] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const { displayMode } = usePortfolio(); // ✅ ดึง displayMode จาก contex
  
useEffect(() => {
  if (stock && isOpen) {
    // เลือกค่าจากฟิลด์ที่มีอยู่จริงใน JSON ของคุณ
    const currentGain = stock.realizedGain ?? stock.manualRealizedGain ?? 0;
    setNewGain(String(currentGain));
  }
}, [stock, isOpen]);

  if (!isOpen || !stock) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isNaN(Number(newGain))) {
      toast.error('กรุณากรอกตัวเลขให้ถูกต้อง');
      return;
    }

    setIsLoading(true);
    try {
      const stockSymbol = stock.stockSymbol || stock.symbol;
      const subPortId = stock.subPortId || subPortfolioId;
      
      if (displayMode === 'V1') {
        // 🟢 Logic V1: ใช้ Endpoint ใหม่ที่คุณเพิ่งเพิ่มเข้าไป
        await updateRealizedGainV1(portfolioId, subPortId, stockSymbol, {
          realizedGain: Number(newGain),
          action: 'overwrite'
        });
        toast.success('แก้ไข Realized Gain (V1) สำเร็จ');
      } else {
        // 🔵 Logic V2: ใช้ Transaction เดิม
        await createV2Transaction(portfolioId, {
          subPortId: subPortId,
          assetSymbol: stockSymbol,
          type: 'REALIZED_GAIN',
          amount: Number(newGain) - (stock.realizedGain || 0),
          transactionDate: new Date().toISOString(),
          note: `ปรับ Realized Gain เป็น ${newGain}`
        });
        toast.success('แก้ไข Realized Gain (V2) สำเร็จ');
      }

      onSave();
      onClose();
    } catch (error: any) {
      console.error(error);
      toast.error(error.message || 'เกิดข้อผิดพลาดในการบันทึก');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative w-full max-w-sm bg-[#18181b] border border-gray-700 rounded-xl shadow-2xl flex flex-col animate-fadeIn">
        <div className="flex justify-between items-center px-5 py-4 border-b border-gray-700">
          <h2 className="text-lg font-bold text-yellow-400">แก้ไขกำไรจริง (Realized Gain)</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-xl">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="p-5 flex flex-col gap-4">
          <div className="bg-gray-800 p-3 rounded-lg border border-gray-700 text-sm">
            <div className="text-gray-400 mb-1">หุ้น: <span className="text-white font-bold">{stock.stockSymbol || stock.symbol}</span></div>
            <div className="text-gray-400">ค่าปัจจุบัน: <span className="text-blue-400 font-bold">{Number(stock.realizedGain ?? stock.manualRealizedGain ?? 0).toLocaleString()}</span></div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">ค่ากำไรใหม่ที่ต้องการตั้ง (New Value)</label>
            <input
              type="number"
              step="any"
              value={newGain}
              onChange={(e) => setNewGain(e.target.value)}
              className="w-full px-4 py-2.5 bg-gray-900 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-yellow-400"
              placeholder="ตัวอย่าง: 500"
              required
            />
          </div>

          <div className="flex justify-end gap-3 mt-2">
            <button type="button" onClick={onClose} disabled={isLoading} className="px-4 py-2 text-sm font-bold text-gray-400 hover:text-white transition-colors">ยกเลิก</button>
            <button type="submit" disabled={isLoading} className="px-4 py-2 text-sm font-bold text-black bg-yellow-400 hover:bg-yellow-500 rounded-lg transition-transform active:scale-95 disabled:opacity-50">
              {isLoading ? 'กำลังบันทึก...' : 'บันทึกการแก้ไข'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditRealizeGainModal;